import { Configuration } from '~/api/client/configuration';
import type { BookingsApiApiV1BookingsPostRequest, BookingsApiApiV1BookingsInquiryPostRequest } from '~/api/client/api';
import { BookingsApi } from '~/api/client/api';

import getConfig from 'next/config';
const { publicRuntimeConfig } = getConfig();

const apiConfiguration = new Configuration({
  basePath: publicRuntimeConfig.API_HOST.replace(/\/+$/, ''),
});

const BOOKINGS_API = new BookingsApi(apiConfiguration, apiConfiguration.basePath);

const postBooking = async (paramsObj: BookingsApiApiV1BookingsPostRequest) => {
  return await BOOKINGS_API.apiV1BookingsPost(paramsObj);
};

const postContactForm = async (paramsObj: BookingsApiApiV1BookingsInquiryPostRequest) => {
  return await BOOKINGS_API.apiV1BookingsInquiryPost(paramsObj);
};

export { postBooking, postContactForm };
